import { CircleCheck, CircleX } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useUpdateCatalog } from '../../../../../../../services/modules/catalogs/catalogs.mutations';
import { Catalog } from '../../../../../catalog.types';

interface UseCatalogCardStatusToggleParams {
  catalogId: string;
  isCatalogActive: boolean;
  onCatalogUpdated: (catalog: Catalog) => void;
}

export const useCatalogCardStatusToggle = ({
  catalogId,
  isCatalogActive,
  onCatalogUpdated,
}: UseCatalogCardStatusToggleParams) => {
  const { isPending, mutate } = useUpdateCatalog({ catalogId });

  const toggleStatus = () => {
    if (isPending) {
      return;
    }

    mutate({ active: !isCatalogActive }, { onSuccess: onCatalogUpdated });
  };

  return {
    statusActionLabel: isCatalogActive ? LangEnum.GLOBAL_INACTIVATE : LangEnum.GLOBAL_ACTIVATE,
    statusActionIcon: isCatalogActive ? CircleX : CircleCheck,
    toggleStatus,
  };
};
